

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import heroSlides from "../data/heroSlides";

export default function HeroSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + heroSlides.length) % heroSlides.length
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  const slide = heroSlides[currentSlide];

  return (
    <section className="relative h-[600px] w-full overflow-hidden" dir="rtl">
      
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center transition-all duration-700"
        style={{
          backgroundImage: `url(${slide.image})`,
        }}
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50" />

      {/* Content */}
      <div className="relative z-10 flex h-full items-center">
        <div className="mx-auto w-full max-w-7xl px-6">
          <div className="max-w-2xl text-white">

            <h1 className="mb-6 text-4xl font-bold leading-tight md:text-6xl">
              {slide.title}
            </h1>

            <p className="mb-8 text-lg leading-8 text-gray-100 md:text-xl">
              {slide.description}
            </p>

            <Link
              to={slide.buttonLink}
              className="inline-flex items-center rounded-lg bg-green-600 px-7 py-3.5 font-semibold text-white transition hover:bg-green-700"
            >
              {slide.buttonText}
            </Link>

          </div>
        </div>
      </div>

      {/* Previous Button */}
      <button
        onClick={prevSlide}
        aria-label="الشريحة السابقة"
        className="absolute right-5 top-1/2 z-20 flex h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full bg-white/20 text-2xl text-white backdrop-blur-sm transition hover:bg-white/40"
      >
        ›
      </button>

      {/* Next Button */}
      <button
        onClick={nextSlide}
        aria-label="الشريحة التالية"
        className="absolute left-5 top-1/2 z-20 flex h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full bg-white/20 text-2xl text-white backdrop-blur-sm transition hover:bg-white/40"
      >
        ‹
      </button>

      {/* Dots */}
      <div className="absolute bottom-8 left-1/2 z-20 flex -translate-x-1/2 gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            aria-label={`انتقل إلى الشريحة ${index + 1}`}
            className={`h-2.5 rounded-full transition-all duration-300 ${
              currentSlide === index
                ? "w-8 bg-white"
                : "w-2.5 bg-white/50 hover:bg-white/80"
            }`}
          />
        ))}
      </div>
    </section>
  );
}